import { render, staticRenderFns } from "./BulleNbrNewMessages.vue?vue&type=template&id=e679c5c8&"
import script from "./BulleNbrNewMessages.vue?vue&type=script&lang=js&"
export * from "./BulleNbrNewMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports